import { Component, OnInit } from '@angular/core';
// ----------------INTERFACE----------------------------------
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
// -------------------SERVICES---------------------------------
import { CacheService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { ReportHourmeterFuelService } from '../../services/report-hourmeter-fuel.service';
//------------------------------------------------------------
import { COMPANIES_ID } from 'projects/common/src/app/enumerables/companies-id';
import { IUser } from 'projects/common/src/app/interfaces';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';

@Component({
  selector: 'app-report-hourmeter-fuel',
  templateUrl: './report-hourmeter-fuel.component.html',
  styleUrls: ['./report-hourmeter-fuel.component.scss'],
})
export class ReportHourmeterFuelComponent implements OnInit {
  public tableConfig: ITableConfig;
  public filterConfig: IFilterConfig;
  public dataReport: any;
  public params: IOutputFilter;
  public message: string;
  public hasData: boolean;
  public systemError: string;
  public isMtv = false;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  constructor(
    private reportHourmeterFuelService: ReportHourmeterFuelService,
    private layoutConfigService: LayoutConfigService,
    private tableConfigService: TableConfigService,
    private languageService: LanguageService,
    private datePipe: DatePresentationPipe,
    private cacheService: CacheService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
  ) {
    this.hasData = false;
    this.message = '';
    const companyId = this.cacheService.local('session').user.company.id;
    this.isMtv = companyId === COMPANIES_ID.MTV;
    this.disabledExcelBtn = false;

    if (this.isMtv) {
      this.filterConfig = {
        dates: { required: true },
        shift: { required: true },
        machineType: { required: true, isForMtv: true },
        machineList: { required: true, multiselect: true },
        cleanButton: true,
      };
    } else {
      this.filterConfig = {
        dates: { required: true },
        shift: { required: true },
        machineType: { required: true },
        machineList: { required: true, multiselect: true },
        cleanButton: true,
      };
    }
  }

  ngOnInit(): void {
    this.setHeader();
  }
  private setHeader(): void {
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle: 'rpt_hourmeter_and_fuel',
      imageKey: 'report',
      imageType: 'section',
    };

    this.layoutConfigService.setConfig(config);
  }

  public async getDataReportHourmeterFuel($event: IOutputFilter): Promise<void> {
    this.filterConfig.isLoading = true;
    const {
      company: { id: companyId },
    } = this.cacheService.local('session').user as IUser;
    this.params = {
      startDate: $event.startDate,
      endDate: $event.endDate,
      shiftId: $event.shiftId,
      machineTypeId: $event.machineTypeId,
      machineId: $event.machineId,
      companyId,
    };
    try {
      let response = await this.reportHourmeterFuelService.GetReportHourmeterFuel(this.params);
      if (response?.length) {
        response = response.map((td) => {
          td.machineName = td.machineName || '-';
          td.machineModelName = td.machineModelName || '-';
          td.machineTypeName = td.machineTypeName || '-';
          td.operatorName = td.operatorName || '-';
          td.horometer = td.horometer || '-';
          td.fuelLevelPercentage = td.fuelLevelPercentage || '-';
          td.dateAt = td.dateAt || '-';

          // Reorder the object properties to ensure the correct order in the table
          return {
            machineName: td.machineName,
            machineModelName: td.machineModelName,
            machineTypeName: td.machineTypeName,
            operatorName: td.operatorName,
            horometer: td.horometer,
            fuelLevelPercentage: td.fuelLevelPercentage,
            dateAt: td.dateAt,
          };
        });

        this.setTableDetailsConfig(response);
        this.hasData = true;
        this.message = '';
      } else {
        this.hasData = false;
        this.message = this.languageService.message('m034');
      }
      this.systemError = '';
    } catch ({ name }) {
      this.hasData = false;
      this.message = '';
      this.systemError = name === 'TimeoutError' ? 'm014' : 'm017';
    } finally {
      this.filterConfig.isLoading = false;
    }
    const filters = {
      reports: 'report-hourmeter-fuel',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }
  public setTableDetailsConfig(tableData: any): void {
    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns: ['machineId', 'machineTypeId', 'zoneId', 'shiftId'],
      replaceColumnName: [
        { prevName: 'machineModelName', newName: 'machine_model' },
        { prevName: 'sectorName', newName: 'sector' },
        { prevName: 'zoneName', newName: 'zone' },
        { prevName: 'mapPoint', newName: 'point' },
        { prevName: 'machineTypeName', newName: 'machine_type' },
        { prevName: 'hourMeter', newName: 'hourMeter' },
        { prevName: 'fuelLevel', newName: 'fuelLevel' },
      ],
      sortables: ['machineName', 'machineTypeName', 'dateAt'],
    };
    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns: ['machineId', 'machineTypeId', 'zoneId', 'shiftId'],
      dateConfig: [{ field: 'dateAt', format: 'date-time' }],
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = { header, dataset };
  }
  /**
   * Executes excel download
   */
  public downloadExcel(): void {
    const selectRangeDate = {
      startDate: this.datePipe.transform(this.params.startDate),
      endDate: this.datePipe.transform(this.params.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.reportHourmeterFuelService.GetReportHourmeterFuelExcel(this.params).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'rpt_hourmeter_and_fuel', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
